<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <b-row>
            <b-col sm=8>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>Bark Parental Control</strong>
                    </div>
                    <div>
                        <b-form @submit.stop.prevent="onSubmit">

                            <b-form-group label="Service:" label-for="TRL_service">
                                <b-form-select size="sm" key="Bark service" v-model="device.config.TRL.TRLConfig.TRL.service" :options="TRLOptions" v-validate="'required'" data-vv-validate-on="change" id="TRL_service" name="Bark Service" class="form-control" :class="{'is-invalid': submitted && verrors.has('Bark Service')}" :readonly=!readonly>
                                </b-form-select>
                            </b-form-group>



                            <div class="text-center">
                                <!-- TODO only activate when dirty -->
                                <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Save</button>
                                <!--  <b-button type="reset" variant="danger">Reset</b-button> -->
                                <!-- <button @click.prevent="reRender">Reset</button> -->
                            </div>
                        </b-form>
                    </div>
                </b-card>

                <!-- <b-card border-variant="light">
                    <div slot="header">
                        <strong>Second Service goes here</strong>
                    </div>
                    <div>
                        <b-form @submit.stop.prevent="onSubmit">
                        </b-form>
                    </div>
                </b-card> -->

            </b-col>
            <b-col sm=4>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>Tasks</strong>
                    </div>
                    <Tasks :device="device" :changed="changed" :changes="changes"></Tasks>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import Tasks from "@/readynet/devices/network/Tasks";

export default {
    components: {
        ValidationProvider,
        Multiselect,
        Tasks,
    },
    props: {
        device: {
            type: Object,
            required: true,
        },
        changed: {
            type: Array,
        },
        changes: {
            type: Object,
        },
    },

    data() {
        return {
            loading: false,
            submitted: false,
            TRLOptions: [
                { text: 'Bark', value: "bark" },
                { text: 'RouterLimits', value: "routerlimits" },

            ],

        }
    },

    methods: {

        mounted() {},
        updateChanged(par, val, nam) {
            for (var i = this.changed.length - 1; i >= 0; i--) {
                if (this.changed[i].param === par) {
                    this.changed.splice(i, 1);
                }
            }
            this.changed.push({ param: par, value: val, name: nam })
            this.$set(this.changes, par, val)
        },

        onSubmit() {
            this.submitted = true;

            this.$validator.validate().then(valid => {

                if (valid) {
                    // need to simplify this
                    if (this.veeFields['Bark Service'].dirty) {
                        this.updateChanged("TRL_service", this.device.config.TRL.TRLConfig.TRL.service, "Bark Service Platform")
                    }

                    // this.$router.push("/#/devices");
                } else {
                    console.log("Bark submitted, INVALID");
                }
            });
        },

    }, // end methods
    computed: {
        readonly() {
            return this.$can('device', 'edit')
        }
    },
};
</script>
// isFormValid () { // // loop over all contents of the fields object and check if they exist and valid or valid == null. // return Object.keys(this.veeFields).every(field => { // return this.veeFields[field] && (this.veeFields[field].valid || (this.veeFields[field].valid == null)); // }); // } // toArray(obj_obj) { // return Object.keys(obj_obj).map(i => obj_obj[i]); // }, // computed:{ // local: { // get() { // return this.params // }, // set(val) { // // this.$emit('input', val) // } // }, // }, // watch:{ // params:{ // // deep: true, // handler(){ // this.my = this.params // } // }, // },

